<script lang="ts">
	import { AssePSCL } from "../../../models/PSCL/Schema/PSCLSchemaProgettazione";

    export let data: AssePSCL[] = [];
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Assi</th>
            <th class="border border-black">Misure</th>
        </tr>
    </thead>
    <tbody>
        {#if data?.length > 0}
            {#each data as asse}
                <tr>
                    <td class="text-center border border-black" rowspan="{asse?.misure?.length + 1}">{asse?.descrizione}</td>
                </tr>
                {#each asse?.misure as misura}
                    <tr>
                        <td class="text-center border border-black">{misura}</td>
                    </tr>
                {/each}
            {/each}
        {:else}
            <tr>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
        {/if}
    </tbody>
</table>